import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=839877ba&scoped=true&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=839877ba&prod&lang=css&"
import style1 from "./Dashboard.vue?vue&type=style&index=1&id=839877ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839877ba",
  null
  
)

export default component.exports